// extracted by mini-css-extract-plugin
export default {"author":"ActivityItem_author__oB4tr","content":"ActivityItem_content__BaJGG","date":"ActivityItem_date__F0DWT","text":"ActivityItem_text__755ot","user":"ActivityItem_user__h9lQL"};